export default function PlanPickerOption({
  plan,
  setSelected,
  selected,
  isMonthly,
}) {
  const { title, pricing, features, isHighlighted } = plan;

  const isSelected = selected === title;

  const handleSelectionChange = () => {
    setSelected(title);
  };

  return (
    <div
      className={
        'sm:tw-flex tw-items-center tw-justify-between tw-max-w-2xl tw-px-8 tw-py-4 tw-mx-auto  tw-cursor-pointer tw-rounded-xl tw-border tw-border-solid ' +
        (isSelected
          ? 'tw-bg-primary-100 dark:tw-bg-primary-900 tw-border-primary-600 dark:tw-border-primary-300 tw-shadow-lg'
          : 'tw-border-gray-100 hover:tw-shadow-md')
      }
      onClick={handleSelectionChange}
    >
      <div className="tw-flex tw-items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={
            'tw-shrink-0 tw-w-5 tw-h-5 sm:tw-h-9 sm:tw-w-9 ' +
            (isSelected
              ? ' tw-text-primary-600 dark:tw-text-primary-300'
              : 'tw-text-gray-400')
          }
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clipRule="evenodd"
          ></path>
        </svg>

        <div className="tw-grow-1 tw-mx-5 tw-space-y-1">
          <div className="tw-flex">
            <h2 className="tw-uppercase tw-text-lg tw-font-medium tw-text-gray-700 sm:tw-text-2xl dark:tw-text-gray-200">
              {title}
            </h2>
            {isHighlighted && (
              <div className="tw-pl-2 tw-pt-1">
                <div className="tw-px-2 tw-text-xs tw-text-primary-600 dark:tw-text-primary-300 tw-bg-gray-100 tw-rounded-full sm:tw-px-4 sm:tw-py-1 dark:tw-bg-gray-700">
                  <span className="tw-hidden sm:tw-inline-block">Most</span>{' '}
                  popular
                </div>
              </div>
            )}
          </div>

          <div>{features}</div>
        </div>
      </div>

      <h2
        className={
          'tw-text-center tw-pt-3 sm:tw-pt-0 sm:tw-text-left tw-shrink-0 tw-text-3xl tw-font-semibold sm:tw-text-4xl ' +
          (isSelected
            ? ' tw-text-primary-600 dark:tw-text-primary-300'
            : 'tw-text-gray-500 dark:tw-text-gray-300')
        }
      >
        <span className="tw-inline-block">
          $
          {pricing.oneTime
            ? pricing.oneTime
            : isMonthly
            ? pricing.monthly
            : pricing.yearly}
        </span>{' '}
        {pricing.oneTime ? (
          <></>
        ) : (
          <span className="tw-text-base tw-font-medium">
            /month
            {isMonthly ? (
              ''
            ) : (
              <>
                <br />
                <div className="tw-text-xs">
                  billed annually as ${pricing.yearly * 12}
                </div>
              </>
            )}
          </span>
        )}
      </h2>
    </div>
  );
}
